<template>
  <Card class="h-full" :pt="{
					body: {
						style: { 'overflow-y': 'hidden' }
					},
					content: {
						style: {
							'overflow-y': 'scroll',
							'border-top': 'solid 1px rgb(203,213,225)',
							'margin-top': '0.75rem',
							'margin-bottom': '-1rem',
						}
					}
				}">
    <template #title>{{ $t('widgets.lists.device_config_updates_list.config_updates') }}</template>
    <template #content>
      <List class="flex-1 overflow-scroll -mx-4 px-4 sm:-mx-6 sm:px-6 h-full -mt-6">
        <DevicesConfigUpdatesListItem
            v-for="activityLog in allActivities"
            :log="activityLog"
            :show-initiated-at="showInitiatedAt"
            :show-initiated-by="showInitiatedBy"
            @click="showConfigUpdateLog(activityLog)"
            class="hover:bg-slate-50 -mx-6 px-6"
        />
      </List>
    </template>
  </Card>

  <DeviceConfigUpdateLogSlideOver ref="slideOver"/>
</template>

<script>
import List from "@/Components/List.vue";
import {mapStores} from "pinia";
import {useDevicesStore} from "@/stores/devices.js";
import DevicesConfigUpdatesListItem from "@/Widgets/Lists/DevicesConfigUpdatesListItem.vue";
import DeviceConfigUpdateLogSlideOver from "@/Slideovers/DeviceConfigUpdateLogSlideOver.vue";

export default {
  name: "DevicesConfigUpdatesList",
  components: {
    DeviceConfigUpdateLogSlideOver,
    DevicesConfigUpdatesListItem,
    List
  },
  data() {
    return {
      activities: [],
      deviceModel: undefined,
    }
  },
  props: {
    device: {
      type: Number,
    },
    showInitiatedAt: {
      type: Boolean,
      default: true,
    },
    showInitiatedBy: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    ...mapStores(useDevicesStore),
    allActivities() {
      return [
        ...this.activities,
      ]
          .filter(a => a.log_name === 'diag++' && a.event === 'config')
          .filter(a => a.properties.config !== undefined)
          .sort((a, b) => Date.parse(b.created_at) - Date.parse(a.created_at));
    },
  },
  methods: {
    async refreshDevice() {
      return this.devicesStore.showDevice(this.device, {
        fields: {devices: 'id,serial_number'},
        include: ['activities.causer'],
      });
    },
    showConfigUpdateLog(log) {
      this.$refs.slideOver.showDeviceConfigUpdateLog(this.deviceModel, log);
    }
  },
  watch: {
    'device': {
      async handler(newValue, oldValue) {
        if (newValue) {
          if (this.device === 'NEW') {
            this.activities = [];
          } else {
            const response = (await this.refreshDevice());
            this.activities = response.activities;
            delete response.activities;
            this.deviceModel = response;
          }
        } else {
          this.activities = undefined;
        }
      },
      immediate: true,
    }
  },
}
</script>

<style scoped>

</style>